import { Outlet } from "react-router-dom";
import CiberBanner from "./CiberBanner";

export default function CiberseguridadLayout() {
  return (
    <>
      <CiberBanner />
      <Outlet />
    </>
  );
}
